import { action, observable } from "mobx";
import { GetCvPortalTranslationOverridesResponse } from "../api/settings/getCvPortalTranslationOverrides";
import { useEffect } from "react";
import { settingsAPI } from "../api/settings";
import { useLatestQuery } from "../api/useLatestQuery";
import { useEvaluatedLocale } from "./useEvaluatedLocale";
import { guid } from "../utils/util";

// translation overrides saved in the database
export const translationOverrides =
  observable.box<GetCvPortalTranslationOverridesResponse | null>(null);

export const translationOverridesSetIndicator = observable.box<string | null>(
  null
);

export function useTranslationOverrides() {
  const evaluatedLocale = useEvaluatedLocale();

  const { data: overrides } = useLatestQuery(
    ["settingsAPI.getCvPortalTranslationOverrides", evaluatedLocale],
    () =>
      settingsAPI.getCvPortalTranslationOverrides({ locale: evaluatedLocale })
  );

  useEffect(
    action(() => {
      translationOverrides.set(overrides);
      translationOverridesSetIndicator.set(guid());
    }),
    [overrides]
  );
}
